(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.main_header_inner.logo_left_menu_center').forEach((header) => {
      if (header.dataset.navFitReady) return;
      const nav = header.querySelector('.header_main_navigation_desktop');
      const menu = nav?.querySelector('.parent_main');
      if (!menu) return;
      header.dataset.navFitReady = 'true';
      const fit = () => {
        header.classList.remove('header_menu_overflow');
        if (window.innerWidth <= 1200) return;
        if (menu.scrollWidth > nav.clientWidth + 1) header.classList.add('header_menu_overflow');
      };
      let width;
      new ResizeObserver((entries) => {
        const nextWidth = entries[0].contentRect.width;
        if (nextWidth !== width) { width = nextWidth; fit(); }
      }).observe(header);
      new MutationObserver(fit).observe(menu, { childList: true, subtree: true, characterData: true });
      document.fonts?.ready.then(fit);
      window.addEventListener('resize', fit, { passive: true });
      fit();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
